import { type PropsWithChildren, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import "./dialog.scss";

const Dialog = ({
  title,
  buttons,
  ok,
  close,
  okLabel,
  children,
}: PropsWithChildren<{
  title: string;
  buttons: ("ok" | "close")[];
  ok?: (() => Promise<void>) | (() => void);
  close?: () => void;
  okLabel?: string;
}>) => {
  const [inProgress, setInProgress] = useState(false);
  const dialogRef = useRef<HTMLDivElement>(null);

  return createPortal(
    <div
      ref={dialogRef}
      className="dialogWrapper"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="dialog">
        <p className="dialogTitle">{title}</p>
        <div className="dialogContent">{children}</div>
        <div className="dialogButtons">
          {buttons.includes("close") && (
            <button
              onClick={(e) => {
                close?.();
              }}
              disabled={inProgress}
            >
              취소
            </button>
          )}
          {buttons.includes("ok") && (
            <button
              onClick={async (e) => {
                setInProgress(true);
                try {
                  await ok?.();
                } finally {
                  setInProgress(false);
                }
              }}
              disabled={inProgress}
            >
              {okLabel || "확인"}
            </button>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default Dialog;
